import { connect } from "react-redux";

import { Actions as TEMPLATEACTIONS } from "../../../store/actions/templateActions";
import Select from "react-select";

const TemplateRow = ({ template, updateSetting, overtimeOptions, allowanceOptions, jurisdiction }) => {
	return (
		<div className="col-xs-12 form-inner-section pr-0 mb-0 pb-0 pt-6">
			<div
				className="col-xs-4"
				style={{ paddingLeft: 0 }}
			>
				<div className="form-material">
					<input
						id="template-type-name"
						className="form-control valid form-input"
						type="text"
						name="name"
						autoComplete="off"
						required
						onChange={(e) => updateSetting(template.id, e.target.name, e.target.value)}
						defaultValue={template.name}
					/>
					<label htmlFor="material-text">Name</label>
				</div>
			</div>
			<div className="col-xs-3">
				<div className="form-material">
					<Select
						valueName="selected"
						options={overtimeOptions}
						value={template?.overtimes}
						placeholder="Choose"
						onChange={(e) => {
							updateSetting(template.id, "overtimes", e);
						}}
						isMulti={true}
					/>
					<label htmlFor="overtimeSelect">Overtimes</label>
				</div>
			</div>
			<div className="col-xs-3">
				<div className="form-material">
					<Select
						valueName="selected"
						options={allowanceOptions}
						value={template?.allowances}
						placeholder="Choose"
						onChange={(e) => {
							updateSetting(template.id, "allowances", e);
						}}
						isMulti={true}
					/>
					<label htmlFor="allowanceSelect">{jurisdiction == "UK" ? "Pay Items" : "Allowances"}</label>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const overtimes = state?.advisors?.settings?.overtimes || [];
	const allowances = state?.advisors?.settings?.allowances || [];

	const overtimeOptions = overtimes?.map((ot) => ({ label: ot?.name, value: ot?.id }));
	const allowanceOptions = allowances?.map((a) => ({ label: a?.name, value: a?.id }));

	return {
		overtimeOptions,
		allowanceOptions,
		jurisdiction: state?.advisors?.settings?.jurisdiction,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateSetting: (id, field, newValue) => dispatch(TEMPLATEACTIONS.updateTemplate(id, field, newValue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateRow);
